import script from "./OrderTableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderTableRow.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__